import { all, update, remove } from '../services/restApi'
import { message } from 'antd'
message.config({top: 110, duration: 4});
const _ = require('underscore')

const limit = 50;

export default {
	namespace : 'client',
	state : {
		clients: [],
		skip: 0,
		limit: limit,
		total_items: 0,
	},
	subscriptions : {
		setup({dispatch, history}) {

			history.listen(location => {
		        if (location.pathname === '/clients') {
		          	dispatch({type: 'firstLoad'})
		        }
		    })
		}
	},
	effects : {
		*firstLoad({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				let query = {};
				let currentUser = JSON.parse(localStorage.getItem('currentUser'));

				if (currentUser.type === 'recepcionista' || currentUser.type === 'gerente') {
					query.hotel = {$in: currentUser.hotels};
				}

				if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId) 
					query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: JSON.parse(localStorage.getItem('currentHotel')).objectId}

				const resp = yield call(all, 'Client', {
					where: query,
					include: 'hotel,createdBy', 
					skip: 0, 
					limit: limit, 
					count: 1, 
					order: '-createdAt'
				})
				const clients = resp.results;

				yield put({ type: 'queryFirst', payload: {
					clients: clients, 
					skip: limit,
					total_items: resp.count,
				}})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
			}

			yield put({type: 'app/hideLoadingTable'})
		},
		*query({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				// Model
				const data = {...payload, include: 'hotel,createdBy'};

				const resp = yield call(all, 'Client', data)
				const clients = resp.results;

				yield put({ type: 'querySuccess', payload: {
					clients: clients,
					skip: payload.skip + limit,
					total_items: resp.count
				}})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
			}

			yield put({type: 'app/hideLoadingTable'})
		},
		*filter({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				const resp = yield call(all, 'Client', {...payload, include: 'hotel,createdBy'})

				yield put({ type: 'filterSuccess', payload: {
					clients: resp.results,
					skip: payload.skip + limit,
					total_items: resp.count
				}})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
			}

			yield put({type: 'app/hideLoadingTable'})
		},
		*update({payload}, {call, put}) {
			yield put({type: 'app/showButtonLoading'})

			try {

				let data = {...payload}
				data.hotel = {__type: 'Pointer', className: 'Hotel', objectId: payload.hotel.key};
				data = _.omit(data, ['objectId', 'createdAt', 'updatedAt']);

				yield call(update, 'Client', payload.objectId, data);
				yield put({ type: 'updateSuccess', payload: {...data, hotel: payload.hotel, objectId: payload.objectId} })
				message.success('Se ha actualizado el cliente exitosamente');

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')	
			}

			yield put({type: 'app/hideButtonLoading'})

		},
		*removeItem({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				yield call(remove, 'Client', payload.objectId);
				yield put({type: 'removeSuccess', payload: payload})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')	
			}

			yield put({type: 'app/hideLoadingTable'})

		}
	},
	reducers : {
		queryFirst(state, action) {
			return {
				...state,
				...action.payload
			}
		},
		querySuccess(state, action) {
			return {
				...state,
				clients: state.clients.concat(action.payload.clients),
				skip: action.payload.skip,
				total_items: action.payload.total_items
			}
		},
		filterSuccess(state, action) {
			return {
				...state,
				clients: action.payload.clients,
				skip: action.payload.skip,
				total_items: action.payload.total_items
			}
		},
		updateSuccess(state, action) {
			const obj = _.find(state.clients, {objectId: action.payload.objectId})
			_.extend(obj, action.payload)
			return {
				...state,
    			...action.payload
			}
		},
		removeSuccess(state, action) {
			return {
				...state,
    			clients: _.without(state.clients, action.payload)
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/models/client.js